import { Box, Card, CardContent, CardHeader } from "@mui/material";
import { DeleteIcon, MoveUpIcon, MoveDownIcon } from "../../../../../common/icons/Icons";
import MultiImageUploader from "../../../../../common/MultiImageUploader";
import { ValidatedTextInput } from "../../../../../common/inputs/ValidatedInputs";

const GallerySectionEditor = ({
  section,
  index,
  isFirst,
  canMoveUp,
  canMoveDown,
  onDisplayNameChange,
  onPicturesChange,
  onMoveUp,
  onMoveDown,
  onRemove
}) => (
  <Card sx={{ mb: 2 }}>
    <CardHeader
      title={
        <ValidatedTextInput
          id={section.id}
          size="small"
          label="Section name"
          value={section.displayName || ''}
          required={!isFirst}
          onChange={(id, value, valid) => onDisplayNameChange(value)}
          placeholder={isFirst ? 'Leave blank for main gallery' : 'e.g. Siedlisko'}
          sx={{ minWidth: 300 }}
        />
      }
      action={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          {!isFirst && (
            <>
              <MoveUpIcon
                onClick={onMoveUp}
                disabled={!canMoveUp}
                size="small"
                childProps={{ fontSize: 'small' }}
              />
              <MoveDownIcon
                onClick={onMoveDown}
                disabled={!canMoveDown}
                size="small"
                childProps={{ fontSize: 'small' }}
              />
              <DeleteIcon
                onClick={onRemove}
                title="Remove section"
                size="small"
              />
            </>
          )}
        </Box>
      }
    />
    <CardContent>
      <MultiImageUploader
        images={section.pictures || []}
        onChange={onPicturesChange}
      />
    </CardContent>
  </Card>
);

export default GallerySectionEditor;
